import React from 'react';
import { SiGitlab } from 'react-icons/si';

import { gitlabLogin } from '../../utils/services/gitlab-service';

import './GitlabLoginButton.scss';

function GitlabLoginButton() {
	return (
		<div
			title="Login com Gitlab"
			onClick={gitlabLogin}
			className="github-login">
			<SiGitlab />
			<span>Login com Gitlab</span>
		</div>
	);
}

export default GitlabLoginButton;
